import { useEffect, useState } from 'react'
import './RouteFallback.css'

/**
 * Suspense fallback for lazily-loaded routes.
 *
 * A skeleton shaped like .tool-container rather than a spinner, with a reserved
 * min-height so swapping it for the real page doesn't shift layout. Held back for
 * 150ms so a fast chunk load doesn't flash a skeleton on screen.
 */
function RouteFallback() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 150)
    return () => clearTimeout(t)
  }, [])

  if (!visible) return <div className="route-fallback-spacer" />

  return (
    <div className="route-fallback" role="status" aria-label="Loading">
      <div className="route-fallback-bar route-fallback-title" />
      <div className="route-fallback-bar route-fallback-subtitle" />
      <div className="route-fallback-card" />
      <span className="visually-hidden">Loading…</span>
    </div>
  )
}

export default RouteFallback
